import React, { memo } from 'react';
import type { JSX } from 'react';

import { Props } from '@/ui/components/Heading/types';

/**
 * @deprecated Do not use this component. There is no equivalent yet at the root
 * of the UI folder — a new version should be built there using the current
 * design-system patterns (tailwind-variants + Headless UI, see src/ui/Button)
 * instead of using this legacy component.
 */
const Heading = ({ className = '', value, text, title, children }: Props) => {
  let Tag: keyof JSX.IntrinsicElements;
  let cssClassName = className;

  switch (value) {
    case 1:
      Tag = 'h1';
      cssClassName += ` text-2xl`;
      break;
    case 2:
      Tag = 'h2';
      cssClassName += ' text-xl';
      break;
    case 3:
      Tag = 'h3';
      cssClassName += ' text-lg';
      break;
    case 4:
      Tag = 'h4';
      cssClassName += ' text-base';
      break;
    case 5:
      Tag = 'h5';
      cssClassName += ' text-sm';
      break;
    case 6:
      Tag = 'h6';
      cssClassName += ' text-xs';
      break;
    default:
      Tag = 'h1';
      cssClassName += ' text-2xl';
      break;
  }

  return (
    <Tag className={`${cssClassName} font-bold`} title={title}>
      {text} {children}
    </Tag>
  );
};

export default memo(Heading);
